import { render } from "./RightButtons.vue?vue&type=template&id=8c6c8cd8&scoped=true"
import script from "./RightButtons.vue?vue&type=script&lang=js"
export * from "./RightButtons.vue?vue&type=script&lang=js"

import "./RightButtons.vue?vue&type=style&index=0&id=8c6c8cd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6c8cd8"]])

export default __exports__